import React, { ReactElement } from 'react';
import { PageContent } from './page-content';
import { ProblemInput } from '../containers/problem-input';
import { APP_CFG } from '../appcfg';
import { ProblemOption, PageType, InputData, PageDataParams } from 'its-pages';

export class InputContent extends PageContent {
  public get component(): ReactElement {
    return <ProblemInput inputContent={this} key={this.pageData.seed} />;
  }

  public get pageType(): PageType {
    return PageType.Problem;
  }

  private logAnswers(): void {
    if (APP_CFG.log) {
      const pageData = this.pageData as InputData;
      const options = pageData.options;

      options.forEach((option: ProblemOption): void => {
        const text = option.isCorrectResponse + ' --> ' + option.text;
        APP_CFG.consoleLog(text);
      });
    }
  }
  public constructor(params: PageDataParams) {
    super(new InputData(params));
    this.logAnswers();
  }
}
